module.exports = __webpack_public_path__ + "img/cubitos.6c91cb98.png";